import { Card, Flex, Heading, List, Stack, Text } from '@chakra-ui/react';
import { memo } from 'react';

const GiftCardSummary = () => {
  return (
    <Card.Root w="full" h="fit-content" pb={2} bg="surface.background" borderColor="border.light">
      <Card.Header py={1}>
        <Heading fontSize="sm">Summary</Heading>
      </Card.Header>
      <Card.Body py={1}>
        <Stack gap={4}>
          <Flex flexDir="column" gap={1}>
            <Heading fontSize="sm">No discount code yet</Heading>
            <Text>No code</Text>
          </Flex>
          <Flex flexDir="column" gap={1}>
            <Heading fontSize="sm">Details</Heading>
            <List.Root pl={4} fontSize="sm">
              <List.Item>All customers</List.Item>
              <List.Item>No usage limits</List.Item>
              <List.Item>Active from today</List.Item>
            </List.Root>
          </Flex>
        </Stack>
      </Card.Body>
    </Card.Root>
  );
};

export default memo(GiftCardSummary);
